let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("gAWT7")]).then(() => parcelRequire('aHC81'));